import { useEffect, useState } from "react";
import { useRouter } from "next/router";

const HIDE_BACK_KEY = "hideBack";

/**
 * hideBack：App 内嵌场景隐藏返回按钮/标题/头部。
 *
 * 只看当前 URL：地址栏带 hideBack=true 才隐藏，参数不在（被登录清参、
 * geo 跨站、语言归一化跳转、站内导航抹掉）就恢复显示。不做 sessionStorage 持久化。
 */
export function useHideBack(): boolean {
  const router = useRouter();
  const [hideBack, setHideBack] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const inUrl = new URLSearchParams(window.location.search).get(HIDE_BACK_KEY) === "true";
    setHideBack(inUrl || router.query.hideBack === "true");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.isReady, router.query.hideBack, router.asPath]);

  return hideBack;
}
